import { initMobileMenu } from "./modules/mobileMenu";
import { initCf7Forms } from "./modules/cf7CustomSubmit";
import { initAccordion } from "./modules/accordion";
import { initBookConfirmation } from "./modules/booking";
import { initContactConfirmation } from "./modules/contacts";

window.addEventListener("load", () => {
  initMobileMenu();
  initCf7Forms();
  initAccordion();
  initBookConfirmation();
  initContactConfirmation();
});
